<section class="make-a-plan-hero" global-hero [heroData]="heroData"></section>
<section jump-to [jumpToData]="jumpToData" [activeSection]="jumpToData[0].buttonFragment"></section>
<section id="what-is-screening" what-is-screen></section>
<section id="how-to-screen" how-can-screen></section>
<!-- <section get-screened></section> -->
<section video-section></section>
<section id="screening-results" autoantibodies></section>
<!-- <section cta-bottom [data]="ctaBottomData" class="d-lg-none"></section> -->
<!-- <section cta-bottom [data]="ctaBottomDataDesk" class="d-none d-lg-block"></section> -->
<section find-a-specialist></section>
<section cta-bottom [data]="ctaBottomDataDesk2" class="pt-0"></section>
<review-bar dateText="in June 2026"></review-bar>
